var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAllYearBadge(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "50px",
    viewBox: "0 0 30 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Badge") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.062499 0 0 0 0 0.369226 0 0 0 0 0.049017 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "JOOR-Events---JAN-2021-Update",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Hover-State-Colors",
    transform: "translate(-93.000000, -921.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "JOOR-SHOWCASE",
    transform: "translate(68.000000, 591.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Badge",
    transform: "translate(25.000000, 330.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,0 L30,0 L30,0 L30,35 C30,43.2842712 23.2842712,50 15,50 C6.71572875,50 1.01453063e-15,43.2842712 0,35 L0,15 C-1.01453063e-15,6.71572875 6.71572875,1.52179594e-15 15,0 Z",
    id: "Rectangle",
    fill: "#5C7284"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 4,
    y: 4,
    width: 22,
    height: 42,
    rx: 11
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-1)",
    id: "Evergreen"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#4AA546",
    x: 7,
    y: 0,
    width: 2,
    height: 28,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#4AA546",
    transform: "translate(5.000000, 5.000000) rotate(45.000000) translate(-5.000000, -5.000000) ",
    x: 4,
    y: 0,
    width: 2,
    height: 10,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    fill: "#4AA546",
    transform: "translate(5.000000, 11.000000) rotate(45.000000) translate(-5.000000, -11.000000) ",
    x: 4,
    y: 6,
    width: 2,
    height: 10,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#4AA546",
    transform: "translate(11.000000, 5.000000) scale(-1, 1) rotate(45.000000) translate(-11.000000, -5.000000) ",
    x: 10,
    y: 2.27373675e-13,
    width: 2,
    height: 10,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    fill: "#4AA546",
    transform: "translate(11.000000, 11.000000) scale(-1, 1) rotate(45.000000) translate(-11.000000, -11.000000) ",
    x: 10,
    y: 6,
    width: 2,
    height: 10,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-10",
    fill: "#4AA546",
    transform: "translate(5.000000, 17.000000) rotate(45.000000) translate(-5.000000, -17.000000) ",
    x: 4,
    y: 12,
    width: 2,
    height: 10,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-9",
    fill: "#4AA546",
    transform: "translate(11.000000, 17.000000) scale(-1, 1) rotate(45.000000) translate(-11.000000, -17.000000) ",
    x: 10,
    y: 12,
    width: 2,
    height: 10,
    rx: 1
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllYearBadge);
export default __webpack_public_path__ + "static/media/all_year-badge.f892e6e4.svg";
export { ForwardRef as ReactComponent };